import { Form, Formik } from "formik";
import P from "../../shared/typography/P";
import FormikCheckbox from "../../shared/ui/Form/FormikCheckBox";
import FormikLabeledInput from "../../shared/ui/Form/FormikLabeledInput";
import { FormRadioGroup } from "../../shared/ui/Form/FormRadioGroup";
import { filtersValidationSchema } from "../../shared/ui/Form/schema";

const Filters = ({
    selectedFilter,
    onFilterChange,
    handleChange,
    ProposalGen,
    onSearchValueChange,
    formData,
}) => {
    const initialValues = {
        filter: selectedFilter,
        proposalGen: ProposalGen,
        propertyName: formData?.propertyName || "",
        searchName: formData?.searchName || "",
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={filtersValidationSchema}
            onSubmit={() => {}}
        >
            <Form className="flex flex-col gap-3 items-start xl:flex-row justify-between lg:items-center">
                <div className="flex flex-col space-y-2 items-start xl:flex-row lg:items-center xl:space-x-4 xl:space-y-0">
                    <P className="text-gray-600 font-medium text-nowrap">
                        Filter by:
                    </P>

                    <div className="flex space-x-4">
                        <FormRadioGroup
                            name="filter"
                            value={selectedFilter}
                            options={[
                                { label: "All", value: "All" },
                                { label: "Mine", value: "Mine" },
                            ]}
                            onChange={(val) => {
                                onFilterChange(val);
                            }}
                        />
                        <FormikCheckbox
                            name="proposalGen"
                            label="Proposal not generated"
                            value={ProposalGen}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="flex flex-wrap xl:flex-nowrap justify-between items-center gap-2">
                    <div className="w-[30rem]">
                        <FormikLabeledInput
                            name="propertyName"
                            placeholder="Property Name"
                            type="text"
                            value={initialValues.propertyName}
                            onChange={onSearchValueChange}
                        />
                    </div>
                    <div className="w-[30rem]">
                        <FormikLabeledInput
                            name="searchName"
                            placeholder="Search by ID"
                            type="text"
                            value={initialValues.searchName}
                            onChange={onSearchValueChange}
                        />
                    </div>
                </div>
            </Form>
        </Formik>
    );
};

export default Filters;
